import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Awards from './pages/Awards/Awards'
import Home from './pages/Home/Home';
import Attributions from './pages/Attributions/Attributions';
import Collaborations from './pages/Collaborations/Collaborations';
import Contribution from './pages/Contribution/Contribution';
import Description from './pages/Description/Description';
import Design from './pages/Design/Design'
import Communication from './pages/Communication/Communication';
import Education from './pages/Education/Education'
import Engineering from './pages/Engineering/Engineering';
import Entrepreneurship from './pages/Entrepreneurship/Entrepreneurship';
import Experiments from './pages/Experiments/Experiments';
import HumanPractices from './pages/HumanPractices/HumanPractices';
import Implementation from './pages/Implementation/Implementation';
import Improvement from './pages/Improvement/Improvement';
import Inclusivity from './pages/Inclusivity/Inclusivity';
import Model from './pages/Model/Model';
import Notebook from './pages/Notebook/Notebook';
import PartsCollection from './pages/PartsCollection/PartsCollection';
import Partnership from './pages/Partnership/Partnership';
import Parts from './pages/Parts/Parts';
import ProofofConcept from './pages/ProofofConcept/ProofofConcept';
import Results from './pages/Results/Results';
import Safety from './pages/Safety/Safety';
import Sustainable from './pages/Sustainable/Sustainable';
import Team from './pages/Team/Team';

function App() {
  return (
    <div className='app-container'>
      <Navbar />
      {/* Routes */}
      <BrowserRouter>
        <Routes>
          <Route exact path='/ucopenhagen' element={<Home />} />
          <Route exact path='/ucopenhagen/attributions' element={<Attributions />} />
          <Route exact path='/ucopenhagen/awards' element={<Awards />} />
          <Route exact path='/ucopenhagen/collaborations' element={<Collaborations />} />
          <Route exact path='/ucopenhagen/contribution' element={<Contribution />} />
          <Route exact path='/ucopenhagen/description' element={<Description />} />
          <Route exact path='/ucopenhagen/design' element={<Design />} />
          <Route exact path='/ucopenhagen/communication' element={<Communication />} />
          <Route exact path='/ucopenhagen/education' element={<Education />} />
          <Route exact path='/ucopenhagen/engineering' element={<Engineering />} />
          <Route exact path='/ucopenhagen/entrepreneurship' element={<Entrepreneurship />} />
          <Route exact path='/ucopenhagen/experiments' element={<Experiments />} />
          <Route exact path='/ucopenhagen/human-practices' element={<HumanPractices />} />
          <Route exact path='/ucopenhagen/implementation' element={<Implementation />} />
          <Route exact path='/ucopenhagen/improve' element={<Improvement />} />
          <Route exact path='/ucopenhagen/inclusivity' element={<Inclusivity />} />
          <Route exact path='/ucopenhagen/model' element={<Model />} />
          <Route exact path='/ucopenhagen/notebook' element={<Notebook />} />
          <Route exact path='/ucopenhagen/part-collection' element={<PartsCollection />} />
          <Route exact path='/ucopenhagen/partnership' element={<Partnership />} />
          <Route exact path='/ucopenhagen/parts' element={<Parts />} />
          <Route exact path='/ucopenhagen/proof-of-concept' element={<ProofofConcept />} />
          <Route exact path='/ucopenhagen/results' element={<Results />} />
          <Route exact path='/ucopenhagen/safety' element={<Safety />} />
          <Route exact path='/ucopenhagen/sustainable' element={<Sustainable />} />
          <Route exact path='/ucopenhagen/team' element={<Team />} />
        </Routes>
      </BrowserRouter>
      <Footer/>
    </div>

  );
}

export default App;
